import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import useQuery from '../../modules/react/hooks/useQuery';
import URLDisplay from '../components/urlDisplay';

const GET_DATA = gql`
  query URLDisplayData($id: ID!) {
    page(id: $id) {
      id
      ...urlDisplayPage
    }
  }

  ${URLDisplay.fragments.page}
`;

const propTypes = {
  id: PropTypes.string.isRequired,
};

const defaultProps = {};

const URLDisplayContainer = ({ id, ...rest }) => {
  // TODO: maybe remove fetchPolicy
  const { data } = useQuery(GET_DATA, { variables: { id }, fetchPolicy: 'network-only' });

  if (!data) { return null; }

  return <URLDisplay {...rest} page={data.page} />;
};

URLDisplayContainer.propTypes = propTypes;
URLDisplayContainer.defaultProps = defaultProps;

export default URLDisplayContainer;
